module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6522710dad0e4d577f33e159dc0207ef.png";